import type {
  CoreClientTasksReadParams,
  CoreClientTasksResolveParams,
  CoreCoachTasksBaseCreateParams,
  CoreCoachTasksBaseDeleteParams,
  CoreCoachTasksBaseReadParams,
  CoreCoachTasksBaseUpdateParams,
  CoreCoachTasksCoachAssignParams,
  CoreCoachTasksCoachDeleteParams,
  CoreCoachTasksCoachReadParams,
  CoreCoachTasksCoachUpdateParams,
} from '../types/core/methods';
import type {
  BaseTaskApiModel,
  ClientTaskApiModel,
  CoachOrClientTaskApiModel,
  CoachTaskApiModel,
} from './types';

import {EntityStore} from '../utils/entityStore';

class BaseTaskStore<
  T extends BaseTaskApiModel = BaseTaskApiModel,
> extends EntityStore<
  T,
  CoreCoachTasksBaseReadParams,
  CoreCoachTasksBaseCreateParams,
  CoreCoachTasksBaseUpdateParams,
  CoreCoachTasksBaseDeleteParams
> {}

class ClientTaskStore<
  T extends ClientTaskApiModel = ClientTaskApiModel,
> extends EntityStore<T, CoreClientTasksReadParams> {
  resolve = this._createMethod<CoreClientTasksResolveParams>({
    method: 'client.tasks.resolve',
  });
  resolveBatch = this._createBatchMethod<CoreClientTasksResolveParams>({
    method: 'client.tasks.resolve',
  });
}

class CoachTaskStore<
  T extends CoachTaskApiModel = CoachTaskApiModel,
> extends EntityStore<
  T,
  CoreCoachTasksCoachReadParams,
  object,
  CoreCoachTasksCoachUpdateParams,
  CoreCoachTasksCoachDeleteParams
> {
  assign = this._createMethod<CoreCoachTasksCoachAssignParams>({
    method: 'coach.tasks.coach.assign',
  });
  assignBatch = this._createBatchMethod<CoreCoachTasksCoachAssignParams>({
    method: 'coach.tasks.coach.assign',
  });
}

export class TaskStore<
  T extends CoachOrClientTaskApiModel = CoachOrClientTaskApiModel,
> extends EntityStore<T> {
  base = new BaseTaskStore('base_task', {
    create: 'coach.tasks.base.create',
    delete: 'coach.tasks.base.delete',
    fetch: 'coach.tasks.base.read',
    update: 'coach.tasks.base.update',
  });
  client = new ClientTaskStore('task', {
    fetch: 'client.tasks.read',
  });
  coach = new CoachTaskStore('coach_task', {
    delete: 'coach.tasks.coach.delete',
    fetch: 'coach.tasks.coach.read',
    update: 'coach.tasks.coach.update',
  });
}

export const taskStore = new TaskStore('task');
